var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakewise2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 48L0.150635 37.86L20.0106 28.12V48Z",
    fill: "url(#paint0_linear_76_212)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 48L0.150635 37.88L20.0306 28.12V48H20.0106Z",
    stroke: "#726691",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12L39.8703 37.92L20.0103 48V28.12Z",
    fill: "url(#paint1_linear_76_212)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12L39.8703 37.92L20.0303 48V28.12H20.0103Z",
    stroke: "url(#paint2_linear_76_212)",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7503 22.4L39.8703 37.9L20.0103 28.1L31.7503 22.4Z",
    fill: "url(#paint3_linear_76_212)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7703 22.4L39.8703 37.9L20.0103 28.12L31.7503 22.38L31.7703 22.4Z",
    stroke: "#B5A7DB",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29061 22.36L20.0106 28.12L0.130615 37.84L8.29061 22.36V22.36Z",
    fill: "url(#paint4_linear_76_212)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29063 22.36L20.0306 28.1L0.150635 37.86L8.29063 22.36V22.36Z",
    stroke: "#8073A3",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0105 28.12V0.0200195L8.31055 22.38L20.0505 28.12H20.0105Z",
    fill: "url(#paint5_linear_76_212)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 28.12V0L8.33057 22.36L20.0506 28.12H20.0106Z",
    stroke: "#9688BD",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12V0.0200195L31.7503 22.4L20.0103 28.12Z",
    fill: "url(#paint6_linear_76_212)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12V0L31.7703 22.4L20.0103 28.1V28.12Z",
    stroke: "#AFA0D8",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 48L0.150635 37.86L20.0106 28.12V48Z",
    fill: "url(#paint7_linear_76_212)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 48L0.150635 37.88L20.0306 28.12V48H20.0106Z",
    stroke: "#726691",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12L39.8703 37.92L20.0103 48V28.12Z",
    fill: "url(#paint8_linear_76_212)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12L39.8703 37.92L20.0303 48V28.12H20.0103Z",
    stroke: "url(#paint9_linear_76_212)",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7503 22.4L39.8703 37.9L20.0103 28.1L31.7503 22.4Z",
    fill: "url(#paint10_linear_76_212)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7703 22.4L39.8703 37.9L20.0103 28.12L31.7503 22.38L31.7703 22.4Z",
    stroke: "#B5A7DB",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29061 22.36L20.0106 28.12L0.130615 37.84L8.29061 22.36V22.36Z",
    fill: "url(#paint11_linear_76_212)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29063 22.36L20.0306 28.1L0.150635 37.86L8.29063 22.36V22.36Z",
    stroke: "#8073A3",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0105 28.12V0.0200195L8.31055 22.38L20.0505 28.12H20.0105Z",
    fill: "url(#paint12_linear_76_212)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 28.12V0L8.33057 22.36L20.0506 28.12H20.0106Z",
    stroke: "#9688BD",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12V0.0200195L31.7503 22.4L20.0103 28.12Z",
    fill: "url(#paint13_linear_76_212)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12V0L31.7703 22.4L20.0103 28.1V28.12Z",
    stroke: "#AFA0D8",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 48L0.150635 37.86L20.0106 28.12V48Z",
    fill: "url(#paint14_linear_76_212)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 48L0.150635 37.88L20.0306 28.12V48H20.0106Z",
    stroke: "#726691",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12L39.8703 37.92L20.0103 48V28.12Z",
    fill: "url(#paint15_linear_76_212)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12L39.8703 37.92L20.0303 48V28.12H20.0103Z",
    stroke: "url(#paint16_linear_76_212)",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7503 22.4L39.8703 37.9L20.0103 28.1L31.7503 22.4Z",
    fill: "url(#paint17_linear_76_212)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7703 22.4L39.8703 37.9L20.0103 28.12L31.7503 22.38L31.7703 22.4Z",
    stroke: "#B5A7DB",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29061 22.36L20.0106 28.12L0.130615 37.84L8.29061 22.36V22.36Z",
    fill: "url(#paint18_linear_76_212)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29063 22.36L20.0306 28.1L0.150635 37.86L8.29063 22.36V22.36Z",
    stroke: "#8073A3",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0105 28.12V0.0200195L8.31055 22.38L20.0505 28.12H20.0105Z",
    fill: "url(#paint19_linear_76_212)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 28.12V0L8.33057 22.36L20.0506 28.12H20.0106Z",
    stroke: "#9688BD",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12V0.0200195L31.7503 22.4L20.0103 28.12Z",
    fill: "url(#paint20_linear_76_212)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12V0L31.7703 22.4L20.0103 28.1V28.12Z",
    stroke: "#AFA0D8",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 48L0.150635 37.86L20.0106 28.12V48Z",
    fill: "url(#paint21_linear_76_212)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 48L0.150635 37.88L20.0306 28.12V48H20.0106Z",
    stroke: "#726691",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12L39.8703 37.92L20.0103 48V28.12Z",
    fill: "url(#paint22_linear_76_212)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12L39.8703 37.92L20.0303 48V28.12H20.0103Z",
    stroke: "url(#paint23_linear_76_212)",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7503 22.4L39.8703 37.9L20.0103 28.1L31.7503 22.4Z",
    fill: "url(#paint24_linear_76_212)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7703 22.4L39.8703 37.9L20.0103 28.12L31.7503 22.38L31.7703 22.4Z",
    stroke: "#B5A7DB",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29061 22.36L20.0106 28.12L0.130615 37.84L8.29061 22.36V22.36Z",
    fill: "url(#paint25_linear_76_212)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29063 22.36L20.0306 28.1L0.150635 37.86L8.29063 22.36V22.36Z",
    stroke: "#8073A3",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0105 28.12V0.0200195L8.31055 22.38L20.0505 28.12H20.0105Z",
    fill: "url(#paint26_linear_76_212)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0106 28.12V0L8.33057 22.36L20.0506 28.12H20.0106Z",
    stroke: "#9688BD",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12V0.0200195L31.7503 22.4L20.0103 28.12Z",
    fill: "url(#paint27_linear_76_212)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 28.12V0L31.7703 22.4L20.0103 28.1V28.12Z",
    stroke: "#AFA0D8",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_212",
    x1: 4.45063,
    y1: 31.18,
    x2: 24.7506,
    y2: 41.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8175A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63577F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_212",
    x1: 19.8503,
    y1: 49.98,
    x2: 34.6103,
    y2: 28.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#73628C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_212",
    x1: 20.0303,
    y1: -173.76,
    x2: 39.8903,
    y2: -173.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73628C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B3A5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_76_212",
    x1: 28.6103,
    y1: 32.7,
    x2: 44.1103,
    y2: 15.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_76_212",
    x1: 10.1706,
    y1: 31.92,
    x2: 12.3506,
    y2: 25.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#887BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796D9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_76_212",
    x1: 22.6905,
    y1: 14.06,
    x2: 12.3905,
    y2: 14.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_76_212",
    x1: 23.3503,
    y1: 17.3,
    x2: 30.6303,
    y2: 24.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_76_212",
    x1: 4.45063,
    y1: 31.18,
    x2: 24.7506,
    y2: 41.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8175A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63577F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_76_212",
    x1: 19.8503,
    y1: 49.98,
    x2: 34.6103,
    y2: 28.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#73628C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_76_212",
    x1: 20.0303,
    y1: -173.76,
    x2: 39.8903,
    y2: -173.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73628C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B3A5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_76_212",
    x1: 28.6103,
    y1: 32.7,
    x2: 44.1103,
    y2: 15.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_76_212",
    x1: 10.1706,
    y1: 31.92,
    x2: 12.3506,
    y2: 25.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#887BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796D9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_76_212",
    x1: 22.6905,
    y1: 14.06,
    x2: 12.3905,
    y2: 14.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_76_212",
    x1: 23.3503,
    y1: 17.3,
    x2: 30.6303,
    y2: 24.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_76_212",
    x1: 4.45063,
    y1: 31.18,
    x2: 24.7506,
    y2: 41.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8175A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63577F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_76_212",
    x1: 19.8503,
    y1: 49.98,
    x2: 34.6103,
    y2: 28.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#73628C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_76_212",
    x1: 20.0303,
    y1: -173.76,
    x2: 39.8903,
    y2: -173.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73628C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B3A5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_76_212",
    x1: 28.6103,
    y1: 32.7,
    x2: 44.1103,
    y2: 15.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_76_212",
    x1: 10.1706,
    y1: 31.92,
    x2: 12.3506,
    y2: 25.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#887BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796D9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_76_212",
    x1: 22.6905,
    y1: 14.06,
    x2: 12.3905,
    y2: 14.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_76_212",
    x1: 23.3503,
    y1: 17.3,
    x2: 30.6303,
    y2: 24.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_76_212",
    x1: 4.45063,
    y1: 31.18,
    x2: 24.7506,
    y2: 41.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8175A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63577F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_76_212",
    x1: 19.8503,
    y1: 49.98,
    x2: 34.6103,
    y2: 28.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#73628C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_76_212",
    x1: 20.0303,
    y1: -173.76,
    x2: 39.8903,
    y2: -173.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73628C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B3A5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_76_212",
    x1: 28.6103,
    y1: 32.7,
    x2: 44.1103,
    y2: 15.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_76_212",
    x1: 10.1706,
    y1: 31.92,
    x2: 12.3506,
    y2: 25.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#887BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796D9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_76_212",
    x1: 22.6905,
    y1: 14.06,
    x2: 12.3905,
    y2: 14.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_76_212",
    x1: 23.3503,
    y1: 17.3,
    x2: 30.6303,
    y2: 24.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFA0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC6E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakewise2);
export default __webpack_public_path__ + "static/media/stakewise_2.f84f032704637b710722f8e433e471e8.svg";
export { ForwardRef as ReactComponent };